import { useState } from "react";
import { Link, NavLink } from "react-router-dom";
import { isLoggedIn, getUser, clearAuth } from "../api/auth";

function Navbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const loggedIn = isLoggedIn();
  const user = getUser();

  const handleSignOut = () => {
    clearAuth();
    window.location.href = "/";
  };

  const close = () => setMenuOpen(false);

  return (
    <nav className="cdh-nav">
      <Link to="/" className="cdh-nav__logo">
        ScriptedCAD
      </Link>

      <ul className={`cdh-nav__links ${menuOpen ? "open" : ""}`}>
        <li><NavLink to="/" end onClick={close} className={({ isActive }) => isActive ? "cdh-nav__link cdh-nav__link--active" : "cdh-nav__link"}>Home</NavLink></li>
        <li><NavLink to="/about" onClick={close} className={({ isActive }) => isActive ? "cdh-nav__link cdh-nav__link--active" : "cdh-nav__link"}>About</NavLink></li>
        <li><NavLink to="/projects" onClick={close} className={({ isActive }) => isActive ? "cdh-nav__link cdh-nav__link--active" : "cdh-nav__link"}>What We Built</NavLink></li>
        {/* Plain anchor, not NavLink: /resources is served by the backend via a
            Netlify proxy, so this must be a real navigation. A client side route
            change would render the old SPA page and never reach the proxy. */}
        <li><a href="/resources" className="cdh-nav__link">Free Resources</a></li>
        <li><NavLink to="/workbooks" onClick={close} className={({ isActive }) => isActive ? "cdh-nav__link cdh-nav__link--active" : "cdh-nav__link"}>Workbooks</NavLink></li>
        <li><NavLink to="/courses" onClick={close} className={({ isActive }) => isActive ? "cdh-nav__link cdh-nav__link--active" : "cdh-nav__link"}>Video Course</NavLink></li>
        <li><NavLink to="/training" onClick={close} className={({ isActive }) => isActive ? "cdh-nav__link cdh-nav__link--active" : "cdh-nav__link"}>Live training</NavLink></li>
      </ul>

      <div className="cdh-nav__right">
        {loggedIn ? (
          <>
            {/* Account cluster: divider, then My Courses to the left of the
                username. Divider only renders alongside the cluster items. */}
            <span className="cdh-nav__divider" aria-hidden="true" />
            <NavLink to="/my-courses" onClick={close} className={({ isActive }) => isActive ? "cdh-nav__link cdh-nav__link--active" : "cdh-nav__link"}>My Courses</NavLink>
            <span className="cdh-nav__user">
              {user?.name?.split(" ")[0] || "Account"}
            </span>
            <button className="cdh-nav__signout" onClick={handleSignOut}>
              Sign out
            </button>
          </>
        ) : (
          <Link to="/login" className="cdh-nav__login">
            Sign in
          </Link>
        )}
        <button
          className="cdh-nav__hamburger"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          <span />
          <span />
          <span />
        </button>
      </div>
    </nav>
  );
}

export default Navbar;
